<template>
  <div>
    <img :src="src"
         @error="setStatus('not')"
         @load="setStatus('loaded')"
         class="cover-image"
         v-show="status === 'loaded'">
    <img :src="loadingImage"
         class="cover-image"
         v-show="status === 'loading'">
    <img :src="errorImage"
         class="cover-image"
         v-show="status === 'not'">
  </div>
</template>

<script>
  export default {
    props: {
      src: {
        type: String,
        required: true
      },
      loadingImage: {
        type: String,
        default: '/link.jpg'
      },
      errorImage: {
        type: String,
        default: '/kalceto.jpg'
      }
    },
    data () {
      return {
        status: 'loading'
      }
    },
    methods: {
      setStatus (status) {
        this.status = status
      }
    }
  }
</script>

<style scoped>
  .cover-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: relative;
  }
</style>
